import { usePhonePortraitContext } from "contexts/phone-portrait-context";
import { AmplitudePageName } from "utils/amplitude";
import getClasses from "utils/getClasses";
import { useCalendarTime } from "../../../../contexts/CalendarTimeContext";
import styles from "./CalendarView.module.scss";
import MonthlyView from "./components/monthly-view/MonthlyView";
import ScrollableCalendarView from "./components/scrollable-calendar-view/ScrollableCalendarView";
import CalendarContextProvider from "./contexts/CalendarContextProvider";
import { useCalendarFreeze } from "./contexts/calendar-freeze-context";
import { useCalendarScroll } from "./contexts/calendar-scroll-context";
import MonthlyViewMobile from "./components/monthly-view-mobile/MonthlyViewMobile";

type Props = { amplitudePageName: AmplitudePageName };

const CalendarView = ({ amplitudePageName }: Props) => {
  const { isPhonePortrait } = usePhonePortraitContext();
  const { currentTimeRangeType } = useCalendarTime();
  const { isFreezed } = useCalendarFreeze();
  const { scrollDisabled } = useCalendarScroll();

  if (isPhonePortrait && currentTimeRangeType === "month") {
    return <MonthlyViewMobile />;
  }

  return (
    <div
      className={getClasses(
        styles["scroll-container"],
        (isFreezed || scrollDisabled) && styles["no-scroll"],
      )}
    >
      <div
        className={getClasses(
          styles["scroll-content"],
          isPhonePortrait && styles.phone,
        )}
      >
        {currentTimeRangeType === "month" ? (
          <MonthlyView amplitudePageName={amplitudePageName} />
        ) : (
          <ScrollableCalendarView
            type={currentTimeRangeType}
            amplitudePageName={amplitudePageName}
          />
        )}
      </div>
    </div>
  );
};

const CalendarViewWithContext = ({ amplitudePageName }: Props) => (
  <CalendarContextProvider>
    <CalendarView amplitudePageName={amplitudePageName} />
  </CalendarContextProvider>
);

export default CalendarViewWithContext;
